import React from "react";
import Typography from "@material-ui/core/Typography";
const Rfq = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Request For Quotation
      </Typography>
      <Typography paragraph variant="h5">
        Conduct bidding to get best offer from vendor
      </Typography>
      <Typography paragraph variant="body1">
        Request For Quotation is one of the features under the Procurement
        module to perform purchasing transactions particularly to ask the
        potential vendors to propose the best price to fulfill the company's
        needs. It contains any information regarding the bidding type,
        requirements classification, currency & exchange rate used for the
        transaction, applied terms & conditions, and the request quotation items
        detail.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Request For
        Quotation list. It is displayed like a table that contains download
        functions, sort, filter, and global search on the header area, and
        contains data navigation and refresh function on the footer area. The
        data column that appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Request For Quotation ID</b>
        <br />
        Indicates the ID of the Request For Quotation.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Bidding Type</b>
        <br />
        Indicates the bidding type of the Request For Quotation. There are 2
        bidding types: Public and Private.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Classification</b>
        <br />
        Indicates the classification of the Request For Quotation.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Bidding Status</b>
        <br />
        Indicates the bidding status of the Request For Quotation. There are 2
        statuses: Opened and Closed.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Quotation Request Date</b>
        <br />
        Indicates the quotation request date of the Request For Quotation.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Response Deadline Date</b>
        <br />
        Indicates the response deadline date of the Request For Quotation.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons and 1 approval indicator that appear on
        each row of Request For Quotation data with specific conditions
        explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Request For Quotation</b>
        <br />
        This button only appears if the Bidding status is 'Opened' and the
        approval indicator is not 'Document Waiting For Approval'. It is used to
        edit the Request For Quotation data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Request For Quotation Detail</b>
        <br />
        This button is used to navigate to the Request For Quotation detail
        which contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Request For Quotation
            data.
          </li>
          <li>
            <b>Vendor Quotations</b> : This tab is to display any Vendor
            Quotations related to the Request For Quotation.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Request For Quotation.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Request For Quotation.
          </li>
        </ul>
        When opening the Request For Quotation detail, there will be 1 button
        appearing on the top section. The button is 'Edit Request For Quotation'
        which is used to edit the Request For Quotation data. The button only
        appear when the Bidding status is 'Opened' and the approval indicator is
        not 'Document Waiting For Approval'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Request For Quotation</b>
        <br />
        This button only appears if the Bidding status is 'Opened' and the
        approval indicator is not 'Document Waiting For Approval'. It is used to
        delete the Request For Quotation data. The Request For Quotation data is
        undeletable once it has relations with other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Approval Indicator</b>
        <br />
        The Request For Quotation document could have an approval flow if it is
        configured. The approval indicator appears as an icon after the document
        ID. There are 4 approval indicators: Document No Need Approval, Document
        Waiting For Approval, Document Approved, and Document Rejected.
      </Typography>
    </React.Fragment>
  );
};

export default Rfq;
